import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject, filter, map, mergeMap, takeUntil } from 'rxjs';
import { UsersService } from 'src/app/private/services/users.service';
import { AuthService } from 'src/app/public/services/auth.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Output() toggleMenuEvent = new EventEmitter<void>();  
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  profileName: any;
  logo: any;
  currentTheme = 'default';
  currentTitle:any
  selectedCenter:any = ""
  centerList:any = [];
  spaciality:any = "";

  userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];

  constructor(private userApi:UsersService, private localStorage:LocalStorageService,private router:Router,private activatedRoute:ActivatedRoute,private auth:AuthService) {
    this.profileName = localStorage.getProfileName();
    this.spaciality = localStorage.getSpecialty();

    this.router.events.pipe(
      filter((ev) => ev instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route:any) => {
        let title = route.data['title'] || '';
        while (route.firstChild) {
          route = route.firstChild;
          title+= route.data['title'];
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data),
    ).subscribe((event:any) => this.currentTitle = event['title']);
  }

  public toggleMenu() {
    this.toggleMenuEvent.emit();
} 
changeCenter(event:any)
{
 let center_id = event.target.value;
 if(center_id)
 {
  localStorage.setItem('center_id', center_id);
  location.reload();
 }
}
  ngOnInit() {
  
   // this.currentTitle = this.route.data['title'] ;
   this.logo = (this.localStorage.getHospitalLogo()!="null") ? this.localStorage.getHospitalLogo() : "assets/img/img.png"
   let param = {
    where:{
      hospital_id:this.localStorage.getHospitalId(),
    }
   }
   this.userApi.getAllCenter(param).subscribe({
    next:(res)=>{
      if(res)
      {
        this.centerList = res;
        this.selectedCenter = this.localStorage.getCenterId();
      }
    },
    error:(e)=>{}
   })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
  }

  toggleSidebar(): boolean {
    return false;
  }

  navigateHome() {
    return false;
  }
  logout()
  {
    this.auth.logOut();
    this.router.navigate(['login'])
  }
}
